import React from 'react';
import HomeSlider from './HomeSlider';
import HomeContentBoxesContainer from './HomeContentBoxesContainer';
import Assets from '../../Assets';

class HomePage extends React.Component {
    render() {
        return (
            <div className="page-body-wrapper home-page">
                <HomeSlider/>
                <HomeContentBoxesContainer contentBoxes={this.props.contentBoxes}/>

                <div className="page-container">
                    <a href="https://www.linkedin.com/company/cetetherm" target="_blank" className="homepage-linkedin">
                        <img src={Assets.linkedinLogo}/>
                        <span>Keep up to date!</span>
                        <span>Follow us on LinkedIn</span>
                    </a>
                </div>
            </div>
        );
    }
}

window.components.HomePage = HomePage